import React from 'react';

import Image from 'Component/Image';
import { ORDER_SHIPMENTS } from 'Component/MyAccountOrder/MyAccountOrder.config';
import {
    MyAccountOrderItemsTableRow as SourceMyAccountOrderItemsTableRow
} from 'SourceComponent/MyAccountOrderItemsTableRow/MyAccountOrderItemsTableRow.component';
import { formatPrice } from 'Util/Price';

import './MyAccountOrderItemsTableRow.override.style';

/** @namespace PeggysagePwa/Component/MyAccountOrderItemsTableRow/Component */
export class MyAccountOrderItemsTableRowComponent extends SourceMyAccountOrderItemsTableRow {
    renderItemVisual() {
        const { product: { product: { thumbnail: { label, url } = {} } = {} } } = this.props;

        if (!url) {
            return null;
        }

        return (
            <Image
              src={ url }
              mix={ { block: 'MyAccountOrderItemsTableRow', elem: 'Picture' } }
              ratio="custom"
              alt={ label }
            />
        );
    }

    renderContenance() {
        const { product: { product: { contenance_label } = {} } } = this.props;

        if (!contenance_label) {
            return null;
        }

        return (
            <div block="MyAccountOrderItemsTableRow" elem="Contenance">
                { contenance_label }
            </div>
        );
    }

    renderSku() {
        const { product: { product_sku } } = this.props;

        return (
            <div block="MyAccountOrderItemsTableRow" elem="Sku">
                { __('SKU: %s', product_sku) }
            </div>
        );
    }

    renderSkuAndContenance() {
        return (
            <div block="MyAccountOrderItemsTableRow" elem="SkuAndContenance">
                { this.renderContenance() }
                { this.renderSku() }
            </div>
        );
    }

    /**
     * Override: remove td, use original product name
     * @returns {JSX.Element}
     */
    renderNameAndOptions() {
        const { product: { product_name, product: { name } = {} } } = this.props;

        return (
            <>
                <div
                  block="MyAccountOrderItemsTableRow"
                  elem="Name"
                >
                    { name || product_name }
                </div>
                { this.renderSelectedAndEnteredOptions() }
            </>
        );
    }

    /**
     * Override: remove tr/td
     * @param item
     * @param isLastOptionItem
     * @returns {JSX.Element}
     */
    renderOptionItem(item, isLastOptionItem) {
        const { qty, title } = item;

        return (
            <div
              block="MyAccountOrderItemsTableRow"
              elem="BundleGroupValue"
              mods={ { isLastOptionItem } }
              key={ `${qty}-${title}` }
            >
                { `${qty} x ${title}` }
            </div>
        );
    }

    /**
     * Override: remove tr/td
     * @param option
     * @param index
     * @returns {JSX.Element|null}
     */
    renderEnteredOptionAsRow(option, index) {
        const { enteredOptions } = this.props;
        const { label, items } = option;
        const { renderOptionItem } = this.renderMap;

        if (!items) {
            return null;
        }

        const isLastOptionItem = enteredOptions.length - 1 === index;

        return (
            <div
              block="MyAccountOrderItemsTableRow"
              elem="Option"
              mods={ { isBundle: true } }
              key={ `${label}-${index}` }
            >
                <div block="MyAccountOrderItemsTableRow" elem="BundleGroupTitle">
                    <strong>{ `${label}:` }</strong>
                </div>
                <div block="MyAccountOrderItemsTableRow" elem="BundleGroupValues">
                    { items.map((item) => renderOptionItem(item, isLastOptionItem)) }
                </div>
            </div>
        );
    }

    /**
     * Override: remove td, add label instead of price for free products
     * @param value
     * @param currency
     * @param title
     * @returns {JSX.Element}
     */
    renderPrice(value, currency) {
        const { product: { quantity_ordered = 1 } } = this.props;

        if (value === 0) {
            const label = quantity_ordered > 1 ? __('Offerts') : __('Offert');

            return (
                <div block="MyAccountOrderItemsTableRow" elem="Price">
                    <span>{ label }</span>
                </div>
            );
        }

        return (
            <div
              block="MyAccountOrderItemsTableRow"
              elem="Price"
            >
                <strong>{ formatPrice(value, currency) }</strong>
            </div>
        );
    }

    /**
     * Override: show simple quantity
     * @returns {JSX.Element}
     */
    renderRowQty() {
        const { product: { quantity_ordered = 1 } } = this.props;

        return (
            <div
              block="MyAccountOrderItemsTableRow"
              elem="Qty"
            >
                { __('Quantity: %s', quantity_ordered) }
            </div>
        );
    }

    /**
     * Override: replace table by divs
     * @returns {JSX.Element}
     */
    renderTableRow() {
        const {
            activeTab,
            enteredOptions = [],
            comments
        } = this.props;

        const isWithEnteredItems = !!enteredOptions[0]?.items;
        const lineBefore = !!((activeTab === ORDER_SHIPMENTS) && (comments.length));

        return (
            <div block="MyAccountOrderItemsTableRow" mods={ { isWithEnteredItems, lineBefore } }>
                <div block="MyAccountOrderItemsTableRow" elem="Visual">
                    { this.renderItemVisual() }
                </div>
                <div block="MyAccountOrderItemsTableRow" elem="Content">
                    { this.renderNameAndOptions() }
                    { this.renderSkuAndContenance() }
                    { this.renderEnteredOptionsAsRow() }
                    <div block="MyAccountOrderItemsTableRow" elem="WrapperPrice">
                        { this.renderRowQty() }
                        { /* this.renderItemPrice() */ }
                        { this.renderRowSubtotal() }
                    </div>
                </div>
            </div>
        );
    }
}

export default MyAccountOrderItemsTableRowComponent;
